export const DEFAULT_VALUES = {
  defaultCountryState: null,
  currencyState: '€',
};
